module.exports = __webpack_public_path__ + "img/teamviewer.80ac82e9.svg";